var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._l((_vm.lazymaster),function(lm,index){return _c('v-row',{key:index,staticClass:"my-10 white--text",style:('background-color:' + lm.color + ';')},[_c('lazy-master-image',{attrs:{"index":index,"lm":lm}}),_c('lazy-master-description',{attrs:{"index":index,"lm":lm}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }